// report 模組 W3：特殊頁群 3 頁的整頁 body（批次 14，Gitea issue #22）。
//
// 行號基準＝ePortfolio_work/ePortfolio-tsgh（逐檔 grep -n 親驗 2026-09-24）。
//
//   1. coreSkillStatistic（核心技能完成率統計圖表，tsgh/coreSkillStatistic.jsp）：
//      雙欄表單（左：學年度 required／醫院 required／訓練類別 required／科部 hidden 群／
//      訓練計畫 required（:196 星）／核心技能低標數值 min number value=20 required（:215）／
//      核心技能高標 max number value=30 required（:221）／EXCEL匯入名單 uploadExcel file
//      accept=.xlsx（:228）／查詢＋EXCEL匯入範本下載（:233-234）；右：annualId2/organizationId2/
//      jobTypeId2/departmentId2 hidden/planTargetId2（:246 星））。
//      doQuery（:105-142）：valid → 未選擇訓練計畫（:110）→ 核心技能低標數值須為正整數
//      （:114-117，isInputInt :94-103）→ 高標 → getCoreSkillStatisticAjax → 成功
//      **window.open('tsghrpt/prompt/coreSkillStatisticReport')**（:138）＝雛形提示呈現
//      （B1-3 模式；真開窗需後端 session 資料）。downloadTemplate（範本下載）＝提示呈現。
//   2. coreSkillStatisticReport（核心技能認證情形，tsgh/coreSkillStatisticReport.jsp）：
//      列印鈕（:76；printMe :63-66＝window.print）＋planName h4（:81）＋核心技能認證情形 h4
//      （:82）＋表（總和/低標title/中標title/高標title，thead :90；tbody :98 起，列 人數/認證比率，
//      認證比率 :106）＋pie 圖（不引）。
//      資料來源＝window.opener.reportData（:9-10）；雛形以種子單列呈現【雛形值待實機校準】。
//   3. academicMOM（學術會議紀錄，tsgh/academicMOM.jsp＋js-my/academicMOM.js）：
//      查詢表單（醫院 靜態三軍總醫院 value=7 無 name／訓練類別 jobTypeId 無 name／
//      部門 departmentId **select-multiple** 契約欄／課程月份 StartDate/EndDate required
//      dateMonth／狀態 無 name 靜態已完成）＋查詢（:95）/設定基準數量（:97）/Excel 鈕。
//      initBeginDate js:112-118 預填上個月（getMonth 無 +1＝legacy bug；1 月會出現 '2026-00'）。
//      doQuery（js:214-255）：日期選取不正確!（js:222，isAfterOrSame）→ 請選擇訓練類別
//      （js:227）→ 請選擇部門（js:231，multi 空陣列）→ getMOMData → 主表
//      （12 欄 thead :113-128 區塊：部門＋9 課型＋完成度＋備註；儲存格 click→showDetail js:126-151
//      →finishModal；完成度＝sumActual/totalLimit×100 四捨五入 2 位 js:275-278；
//      **小兒科部固定備註『 影像、臨床病理、死亡，一個月有寫到一種即算完成。完成度需人工再次確認。』
//      js:279-283**）。
//      getExcel（js:290-330）：同三段驗證 → downloadExcel → 下載失敗，請聯絡系統管理員（js:328）。
//      setBase（js:334-341）→ 設定基準數量 modal（#dialogModal，JSP :172-297）：學年度
//      d_annualId／醫院 d_organizationId 靜態三軍總醫院／訓練類別 d_jobTypeId＋查詢鈕（:211；
//      getBase js:342-370：請選擇學年度/醫院/訓練類別——**legacy 第三段檢核讀主表 #jobTypeId
//      js:352＝copy-paste 瑕疵** → getMOMBaseData → makeBaseTable js:377-386：d_annual=
//      annual+"年度"（:378）、**d_createUser＝'最新更新人員：'+createUserName+' '+crateDate
//      （:379，crateDate legacy typo 照實）**＋基準數表 10 欄（thead :261-277））；匯入課程類別
//      基準數量 uploadFile＋檔案匯入（doImport js:394-437：空 → info『請選擇匯入的檔案』（:397）；→
//      confirm『是否確定要匯入?』（:400-401）→ importExcel → 成功 info(desc)／失敗 alert(desc＋第N行：…)）；
//      範本下載×3（西醫UGY/中醫UGY/牙醫PGY 範本下載）；說明 li×2（若資料已存在，將更新系統資料。/
//      請務必維護當年度各部門的課類別基準數量。）；關閉。finishModal（已完成表單，JSP :149-168；
//      動態表頭，雛形三欄種子）。
//
// 雛形資料策略：結果表/基準數表/明細＝resource-rules 種子（MOM_RESULT_SEED/MOM_BASE_SEED/
// MOM_DETAIL_SEED/CORE_SKILL_STATISTIC_REPORT_SEED）；查詢真打 list filters（種子帶查詢鍵值
// 【雛形值待實機校準】）；Excel＝list export:true；檔案匯入/範本下載/列印/開新窗＝提示呈現
// （不帶 data-effect）。
// 【證據等級】§7 第 3 級（原始碼）。

import { useState, useEffect, type ReactElement } from 'react';
import { Button } from '@/components/base/Button';
import { PieCanvas, CHART_COLORS } from '@/components/base/ChartCanvas';
import { Select } from '@/components/base/Select';
import { Table, type TableColumn, type TableRow } from '@/components/base/Table';
import { ModalFrame, useDialogs } from '@/components/layouts';
import { useDataSource as useMockDataSource } from '@/mocks';
import type { Row } from '@/mocks/types';
import { selectOptionsOverride } from '@/mocks/legacy-fields';
import {
  ACCOUNT_DEPARTMENT_OPTIONS,
  ACCOUNT_JOB_TYPE_OPTIONS,
  ACCOUNT_ORGANIZATION_OPTIONS,
  COURSE_CLAZZ_ANNUAL_OPTIONS,
  COURSE_CLAZZ_PLAN_TARGET_OPTIONS,
  MOM_COURSE_TYPES,
  MOM_DETAIL_SEED,
} from '@/mocks/resource-rules';
import { isAfterOrSame, ReportPanel, ReportRow, runReportExport } from './ReportKit';
import { t } from '@/messages/zh-TW';

// ---------------------------------------------------------------------------
// 1. 核心技能完成率統計圖表（report-tsgh-core-skill-statistic）
// ---------------------------------------------------------------------------

/** isInputInt（coreSkillStatistic.jsp:95-103 鏡像：NaN/<0/非整數 → false）。 */
function isInputInt(value: string): boolean {
  if (Number.isNaN(Number(value))) {
    return false;
  }
  const x = Number.parseFloat(value);
  if (x < 0) {
    return false;
  }
  return Number.isInteger(x);
}

export function CoreSkillStatisticBody({ pageId }: { pageId: string }): ReactElement {
  const dialogs = useDialogs();
  const dataSource = useMockDataSource();
  const [values, setValues] = useState<Record<string, string>>({
    annualId: '114',
    organizationId: '',
    jobTypeId: '',
    departmentId: '',
    planTargetId: '-1',
    min: '20', // value=20（:204）
    max: '30', // value=30（:211）
    uploadExcel: '',
    annualId2: '114',
    organizationId2: '',
    jobTypeId2: '',
    departmentId2: '',
    planTargetId2: '-1',
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  const half = (suffix: string, labeled: boolean) => (
    <>
      {/* 批次 52 修訂（b52-calibrate3，F-2）：OPTION_SET_OVERRIDES 命中＝凍結選項集取代寫死常數
          （規格 §7.1；suffix ''/2 兩組共 8 鍵；override 命中含空陣列即移除 placeholder 空選項）。 */}
      <ReportRow pageId={pageId} name={`annualId${suffix}`} label="學年度：" star={labeled}>
        <Select
          uiId={`${pageId}-field-annual-id${suffix}`}
          name={`annualId${suffix}`}
          value={values[`annualId${suffix}`] ?? ''}
          onChange={(next) => {
            set(`annualId${suffix}`, next);
          }}
          options={selectOptionsOverride(pageId, `annualId${suffix}`) ?? COURSE_CLAZZ_ANNUAL_OPTIONS}
          invalid={labeled && errors[`annualId${suffix}`] !== undefined}
        />
      </ReportRow>
      <ReportRow pageId={pageId} name={`organizationId${suffix}`} label="醫院：" star={labeled}>
        <Select
          uiId={`${pageId}-field-organization-id${suffix}`}
          name={`organizationId${suffix}`}
          value={values[`organizationId${suffix}`] ?? ''}
          onChange={(next) => {
            set(`organizationId${suffix}`, next);
          }}
          options={selectOptionsOverride(pageId, `organizationId${suffix}`) ?? ACCOUNT_ORGANIZATION_OPTIONS}
          {...(selectOptionsOverride(pageId, `organizationId${suffix}`) ? {} : { placeholder: '請選擇' })}
        />
      </ReportRow>
      <ReportRow pageId={pageId} name={`jobTypeId${suffix}`} label="訓練類別：" star={labeled}>
        <Select
          uiId={`${pageId}-field-job-type-id${suffix}`}
          name={`jobTypeId${suffix}`}
          value={values[`jobTypeId${suffix}`] ?? ''}
          onChange={(next) => {
            set(`jobTypeId${suffix}`, next);
          }}
          options={selectOptionsOverride(pageId, `jobTypeId${suffix}`) ?? ACCOUNT_JOB_TYPE_OPTIONS}
          {...(selectOptionsOverride(pageId, `jobTypeId${suffix}`) ? {} : { placeholder: '請選擇' })}
        />
      </ReportRow>
      <div className="hidden">
        <ReportRow pageId={pageId} name={`departmentId${suffix}`} label="科部：" star={labeled}>
          <Select
            uiId={`${pageId}-field-department-id${suffix}`}
            name={`departmentId${suffix}`}
            value={values[`departmentId${suffix}`] ?? ''}
            onChange={(next) => {
              set(`departmentId${suffix}`, next);
            }}
            options={selectOptionsOverride(pageId, `departmentId${suffix}`) ?? ACCOUNT_DEPARTMENT_OPTIONS}
            {...(selectOptionsOverride(pageId, `departmentId${suffix}`) ? {} : { placeholder: '請選擇' })}
          />
        </ReportRow>
      </div>
      <ReportRow
        pageId={pageId}
        name={`planTargetId${suffix}`}
        label="訓練計畫："
        star
        error={labeled ? errors[`planTargetId${suffix}`] : undefined}
      >
        <Select
          uiId={`${pageId}-field-plan-target-id${suffix}`}
          name={`planTargetId${suffix}`}
          value={values[`planTargetId${suffix}`] ?? ''}
          onChange={(next) => {
            set(`planTargetId${suffix}`, next);
          }}
          // 批次 52 種子值校準：planTargetId 凍結真空（OPTION_SET_OVERRIDES=[]）→ override 命中＝0 選項＋無 placeholder（凍結鏈擋＝凍結行為）。
          options={selectOptionsOverride(pageId, `planTargetId${suffix}`) ?? [{ value: '-1', label: '請選擇' }, ...COURSE_CLAZZ_PLAN_TARGET_OPTIONS]}
          {...(selectOptionsOverride(pageId, `planTargetId${suffix}`) ? {} : { placeholder: '請選擇' })}
          invalid={labeled && errors[`planTargetId${suffix}`] !== undefined}
        />
      </ReportRow>
    </>
  );
  return (
    <ReportPanel
      pageId={pageId}
      title="核心技能完成率統計圖表"
      actions={
        <>
          <Button
            uiId={`${pageId}-query-btn`}
            variant="primary"
            size="sm"
            type="button"
            // C5-j：查詢真的呼叫 dataSource.list（filters；legacy 成功後 window.open 報表頁，
            // 雛形以提示呈現——真開窗需後端 session 資料【雛形值待實機校準】）。
            dataEffect={`list:${pageId}`}
            onClick={() => {
              void (async () => {
                // :106-108 valid
                const required: Record<string, string> = {};
                for (const key of ['annualId', 'planTargetId', 'min', 'max']) {
                  if ((values[key] ?? '') === '') {
                    required[key] = '必填欄位';
                  }
                }
                if (Object.keys(required).length > 0) {
                  setErrors(required);
                  return;
                }
                setErrors({});
                // :112 未選擇訓練計畫（== '-1'；雛形同攔空值）。
                if ((values['planTargetId'] ?? '') === '' || (values['planTargetId'] ?? '') === '-1') {
                  await dialogs.alert('未選擇訓練計畫');
                  return;
                }
                // :114-117 核心技能低標數值須為正整數。
                if (!isInputInt(values['min'] ?? '')) {
                  await dialogs.alert('核心技能低標數值須為正整數');
                  return;
                }
                // :118-121 高標。
                if (!isInputInt(values['max'] ?? '')) {
                  await dialogs.alert('核心技能高標數值須為正整數');
                  return;
                }
                try {
                  await dialogs.processing.wrap(
                    dataSource.list(pageId, { page: 1, pageSize: 50, filters: { ...values } }),
                  );
                  // :133-136 window.open('tsghrpt/prompt/coreSkillStatisticReport')——提示呈現。
                  await dialogs.info('雛形不開新窗，統計報表請由選單進入「核心技能認證情形」頁。');
                } catch (cause: unknown) {
                  await dialogs.alert(cause instanceof Error ? cause.message : t('error.generic'));
                }
              })();
            }}
          >
            查詢
          </Button>
          <Button
            uiId={`${pageId}-template-btn`}
            variant="default"
            size="sm"
            type="button"
            // downloadTemplate('核心技能人員匯入範本.xlsx')＝提示呈現（不落地檔案）。
            onClick={() => {
              void dialogs.info(t('export.notice'));
            }}
          >
            EXCEL匯入範本下載
          </Button>
        </>
      }
    >
      {half('', true)}
      {half('2', false)}
      {/* 低標/高標（:203-215 number required，預設 20/30）。 */}
      <ReportRow pageId={pageId} name="min" label="核心技能低標數值：" star error={errors['min']}>
        <input
          data-ui-id={`${pageId}-field-min`}
          name="min"
          type="number"
          required
          className="rounded border border-border px-2 py-1 text-sm"
          value={values['min'] ?? ''}
          onChange={(event) => {
            set('min', event.target.value);
          }}
        />
      </ReportRow>
      <ReportRow pageId={pageId} name="max" label="核心技能高標數值：" star error={errors['max']}>
        <input
          data-ui-id={`${pageId}-field-max`}
          name="max"
          type="number"
          required
          className="rounded border border-border px-2 py-1 text-sm"
          value={values['max'] ?? ''}
          onChange={(event) => {
            set('max', event.target.value);
          }}
        />
      </ReportRow>
      {/* EXCEL匯入名單（:217-222 file accept=.xlsx）。 */}
      <div className="flex items-start gap-2">
        <span className="w-24 shrink-0 text-sm">EXCEL匯入名單：</span>
        <input
          data-ui-id={`${pageId}-field-upload-excel`}
          name="uploadExcel"
          type="file"
          accept=".xlsx"
          className="text-sm"
          onChange={(event) => {
            set('uploadExcel', event.target.files?.[0]?.name ?? '');
          }}
        />
      </div>
    </ReportPanel>
  );
}

// ---------------------------------------------------------------------------
// 2. 核心技能認證情形（report-tsgh-core-skill-statistic-report）
// ---------------------------------------------------------------------------

export function CoreSkillStatisticReportBody({ pageId }: { pageId: string }): ReactElement {
  const dialogs = useDialogs();
  const dataSource = useMockDataSource();
  const [rows, setRows] = useState<readonly Row[]>([]);
  const [, setBusy] = useState(false);
  // 資料來源＝window.opener.reportData（:9-10）；雛形以種子單列呈現（真串接需後端 session）。
  // mount 的 list 呼叫是雛形取種子的機制（legacy 本頁不打任何 ajax）。
  // biome-ignore lint/correctness/useExhaustiveDependencies: pageId 掛載內不變，首載一次。
  useEffect(() => {
    void (async () => {
      setBusy(true);
      try {
        const result = await dataSource.list(pageId, { page: 1, pageSize: 50, filters: {} });
        setRows(result.rows.filter((row) => row['planName'] !== undefined));
      } finally {
        setBusy(false);
      }
    })();
  }, []);
  const data = rows[0];
  return (
    <ReportPanel
      pageId={pageId}
      title="核心技能認證情形"
      actions={
        <Button
          uiId={`${pageId}-print-btn`}
          variant="default"
          size="sm"
          type="button"
          // printMe（:63-66）＝window.print；雛形提示呈現（不帶 data-effect）。
          onClick={() => {
            void dialogs.info('雛形不提供列印流程，此按鈕僅示範列印入口。');
          }}
        >
          列印
        </Button>
      }
    >
      <div className="col-span-2 text-center">
        {/* planName h4（:81）＋核心技能認證情形 h4（:82）。 */}
        <h4 data-ui-id={`${pageId}-plan-name`}>{String(data?.['planName'] ?? '')}</h4>
        <h4>核心技能認證情形</h4>
      </div>
      <div className="col-span-2">
        {/* 表（總和/低標/中標/高標，thead :90-97；列 人數/認證比率，認證比率 :106）。 */}
        <Table
          uiId={`${pageId}-stat-table`}
          columns={[
            { key: 'sum', header: '總和', align: 'center' },
            { key: 'min', header: String(data?.['minTitle'] ?? ''), align: 'center' },
            { key: 'middle', header: String(data?.['middleTitle'] ?? ''), align: 'center' },
            { key: 'max', header: String(data?.['maxTitle'] ?? ''), align: 'center' },
          ]}
          rows={[
            {
              sum: '人數',
              min: String(data?.['minSize'] ?? ''),
              middle: String(data?.['middleSize'] ?? ''),
              max: String(data?.['maxSize'] ?? ''),
            },
            {
              sum: '認證比率', // coreSkillStatisticReport.jsp:106 逐字
              min: `${String(data?.['minPercent'] ?? '')}%`,
              middle: `${String(data?.['middlePercent'] ?? '')}%`,
              max: `${String(data?.['maxPercent'] ?? '')}%`,
            },
          ]}
          rowKey={(row) => String(row['sum'] ?? '')}
        />
      </div>
      {/* RPT-001（批次 33，issue #34）：pie（chart-area，coreSkillStatisticReport.jsp:124；type pie :49）。
          資料＝種子單列的 min/middle/max percent（:29-31）；寫死 3 色 red/green/blue（:33-37）——
          這頁是唯一寫死色的 pie。位置：表格→圖（此頁與其餘 9 頁相反，:89-113 表在前 :115-126 圖在後）。 */}
      <div className="col-span-2" style={{ width: '75%' }}>
        <PieCanvas
          uiId={`${pageId}-chart-area`}
          title="核心技能認證情形"
          slices={[
            { label: String(data?.['minTitle'] ?? ''), value: Number(data?.['minPercent'] ?? 0), color: CHART_COLORS.red },
            { label: String(data?.['middleTitle'] ?? ''), value: Number(data?.['middlePercent'] ?? 0), color: CHART_COLORS.green },
            { label: String(data?.['maxTitle'] ?? ''), value: Number(data?.['maxPercent'] ?? 0), color: CHART_COLORS.blue },
          ]}
        />
      </div>
    </ReportPanel>
  );
}

// ---------------------------------------------------------------------------
// 3. 學術會議紀錄（report-tsgh-academic-mom）
// ---------------------------------------------------------------------------

/** 完成度計算（makeTable js:275-278：sumActual/totalLimit×100 四捨五入 2 位）。 */
function completionOf(row: Row): string {
  const types = Array.isArray(row['courseTypeData']) ? (row['courseTypeData'] as ReadonlyArray<Row>) : [];
  let sumActual = 0;
  for (const entry of types) {
    const actual = Number(entry['actual'] ?? 0);
    const limit = Number(entry['limit'] ?? 0);
    sumActual += actual > limit ? limit : actual;
  }
  const totalLimit = Number(row['totalLimit'] ?? 0);
  const percentage = totalLimit === 0 ? 0 : (sumActual / totalLimit) * 100;
  return `${String(Math.round(percentage * 100) / 100)}%`;
}

/** 儲存格文字（actual/limit；makeTable js:268-274）。 */
function cellTextOf(row: Row, courseTypeName: string): string {
  const types = Array.isArray(row['courseTypeData']) ? (row['courseTypeData'] as ReadonlyArray<Row>) : [];
  const entry = types.find((item) => String(item['courseTypeName'] ?? '') === courseTypeName);
  if (entry === undefined) {
    return '';
  }
  return `${String(entry['actual'] ?? '')}/${String(entry['limit'] ?? '')}`;
}

export function AcademicMomBody({ pageId }: { pageId: string }): ReactElement {
  const dialogs = useDialogs();
  const dataSource = useMockDataSource();
  const [values, setValues] = useState<Record<string, string>>({
    organizationId: '7', // 靜態三軍總醫院（無 name）
    jobTypeId: '',
    departmentId: '',
    StartDate: '2025-12', // initBeginDate js:112-118 預填上個月（getMonth 無 +1＝legacy bug）【雛形值待實機校準】
    EndDate: '2025-12',
  });
  const [baseOpen, setBaseOpen] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailTitle, setDetailTitle] = useState('');
  const [baseValues, setBaseValues] = useState<Record<string, string>>({
    annualId: '114',
    d_organizationId: '7',
    jobTypeId: '',
    uploadFile: '',
  });
  const [baseRows, setBaseRows] = useState<readonly Row[]>([]);
  const [baseMeta, setBaseMeta] = useState<{ annual: string; createUser: string } | null>(null);
  const [detailRows, setDetailRows] = useState<readonly Row[]>([]);
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  const [rows, setRows] = useState<readonly Row[]>([]);
  const [busy, setBusy] = useState(false);

  /** doQuery/getExcel 共用驗證鏉（js:216-233／:292-310）。 */
  const chain = async (): Promise<boolean> => {
    // js:222 日期選取不正確!（isAfterOrSame；月值語意同 finishrate）
    if (!isAfterOrSame(values['StartDate'] ?? '', values['EndDate'] ?? '')) {
      await dialogs.alert('日期選取不正確!');
      return false;
    }
    // js:227 請選擇訓練類別。
    if ((values['jobTypeId'] ?? '') === '') {
      await dialogs.alert('請選擇訓練類別');
      return false;
    }
    // js:231 請選擇部門（multi 空陣列；雛形以空字串）。
    if ((values['departmentId'] ?? '') === '') {
      await dialogs.alert('請選擇部門');
      return false;
    }
    return true;
  };

  const doQuery = () => {
    void (async () => {
      if (!(await chain())) {
        return;
      }
      setBusy(true);
      try {
        const result = await dataSource.list(pageId, {
          page: 1,
          pageSize: 50,
          filters: {
            StartDate: values['StartDate'] ?? '',
            EndDate: values['EndDate'] ?? '',
            organizationId: values['organizationId'] ?? '',
            jobTypeId: values['jobTypeId'] ?? '',
            departmentId: values['departmentId'] ?? '',
            status: '已完成',
          },
        });
        setRows(result.rows.filter((row) => row['departmentName'] !== undefined));
      } catch (cause: unknown) {
        await dialogs.alert(cause instanceof Error ? cause.message : t('error.generic'));
      } finally {
        setBusy(false);
      }
    })();
  };

  const getExcel = () => {
    void (async () => {
      if (!(await chain())) {
        return;
      }
      await runReportExport({
        pageId,
        filters: {
          StartDate: values['StartDate'] ?? '',
          EndDate: values['EndDate'] ?? '',
          jobTypeId: values['jobTypeId'] ?? '',
          departmentId: values['departmentId'] ?? '',
        },
        dataSource,
        dialogs,
      });
    })();
  };

  /** getBase（js:342-370）：請選擇學年度/醫院/訓練類別 → getMOMBaseData → makeBaseTable。 */
  const getBase = () => {
    void (async () => {
      if ((baseValues['annualId'] ?? '') === '') {
        await dialogs.alert('請選擇學年度');
        return;
      }
      if ((baseValues['d_organizationId'] ?? '') === '') {
        await dialogs.alert('請選擇醫院');
        return;
      }
      // js:352 legacy 檢核讀【主表】#jobTypeId、取值卻讀 #d_jobTypeId（:358）＝copy-paste
      // 瑕疵；雛形以 modal 欄檢核＝意圖鏡像【雛形值待實機校準】。
      if ((baseValues['jobTypeId'] ?? '') === '') {
        await dialogs.alert('請選擇訓練類別');
        return;
      }
      const result = await dialogs.processing.wrap(
        dataSource.list(pageId, {
          page: 1,
          pageSize: 50,
          filters: {
            annualId: baseValues['annualId'] ?? '',
            organizationId: baseValues['d_organizationId'] ?? '', // js param 含 organizationId（js:356-360）
            jobTypeId: baseValues['jobTypeId'] ?? '',
          },
        }),
      );
      // makeBaseTable（js:321-341）：基準數列＋d_annual＝annual+"年度"＋d_createUser。
      const base = result.rows.filter((row) => row['showBaseContent'] !== undefined);
      setBaseRows(base);
      setBaseMeta({
        annual: `${String(base[0]?.['annual'] ?? '')}年度`,
        createUser: `最新更新人員：${String(base[0]?.['createUserName'] ?? '')} ${String(base[0]?.['crateDate'] ?? '')}`,
      });
    })();
  };

  /** doImport（js:372-410）：空 → info 請選擇匯入的檔案；confirm 是否確定要匯入? → 雛形成功訊息。 */
  const doImport = () => {
    void (async () => {
      if ((baseValues['uploadFile'] ?? '') === '') {
        await dialogs.info('請選擇匯入的檔案'); // js:374-377 showInfoDialog
        return;
      }
      const confirmed = await dialogs.confirm('是否確定要匯入?'); // js:379
      if (!confirmed) {
        return;
      }
      // importExcel 無真檔案服務（批次 9 匯入同款：不接 mock DataSource、0 data-effect）。
      await dialogs.info('匯入成功（雛形不處理檔案內容）【雛形值待實機校準】');
      setBaseValues((current) => ({ ...current, uploadFile: '' })); // js:406 清空
      getBase();
    })();
  };

  /** showDetail（js:126-151）→ finishModal。 */
  const showDetail = (departmentName: string, courseTypeName: string) => {
    setDetailTitle(`${departmentName} ${courseTypeName}`);
    setDetailRows(MOM_DETAIL_SEED.filter((row) => row['formName'] !== undefined));
    setDetailOpen(true);
  };

  const momColumns: readonly TableColumn[] = [
    { key: 'departmentName', header: '部門', align: 'center' },
    ...MOM_COURSE_TYPES.map((typeName, index) => ({
      key: `ct_${String(index)}`,
      header: typeName,
      align: 'center' as const,
    })),
    { key: 'completion', header: '完成度', align: 'center' },
    { key: 'remark', header: '備註', align: 'center' },
  ];
  const momRows: readonly TableRow[] = rows.map((row) => {
    const cells: Row = { departmentName: row['departmentName'] ?? '' };
    for (const [index, typeName] of MOM_COURSE_TYPES.entries()) {
      cells[`ct_${String(index)}`] = cellTextOf(row, typeName);
    }
    cells['completion'] = completionOf(row);
    // js:279-283 小兒科部固定備註（逐字含前導空格）。
    cells['remark'] =
      String(row['departmentName'] ?? '') === '小兒科部'
        ? ' 影像、臨床病理、死亡，一個月有寫到一種即算完成。完成度需人工再次確認。'
        : '  ';
    return cells;
  });

  const baseColumns: readonly TableColumn[] = [
    { key: 'departmentName', header: '部門', align: 'center' },
    ...MOM_COURSE_TYPES.map((typeName, index) => ({
      key: `base_${String(index)}`,
      header: typeName,
      align: 'center' as const,
    })),
  ];
  const baseTableRows: readonly TableRow[] = baseRows.map((row) => {
    const cells: Row = { departmentName: row['departmentName'] ?? '' };
    const content = Array.isArray(row['showBaseContent']) ? (row['showBaseContent'] as ReadonlyArray<unknown>) : [];
    for (const [index, value] of content.entries()) {
      cells[`base_${String(index)}`] = String(value ?? '');
    }
    return cells;
  });

  return (
    <div data-ui-id={pageId}>
      <ReportPanel
        pageId={pageId}
        title="學術會議紀錄"
        actions={
          <>
            <Button
              uiId={`${pageId}-query-btn`}
              variant="primary"
              size="sm"
              type="button"
              // C5-j：查詢真打 list filters。
              dataEffect={`list:${pageId}`}
              disabled={busy}
              onClick={doQuery}
            >
              查詢
            </Button>
            <Button
              uiId={`${pageId}-setbase-btn`}
              variant="default"
              size="sm"
              type="button"
              onClick={() => {
                // setBase（js:334-341）：清基準數表＋開 modal。
                setBaseRows([]);
                setBaseMeta(null);
                setBaseOpen(true);
              }}
            >
              設定基準數量
            </Button>
            <Button
              uiId={`${pageId}-excel-btn`}
              variant="default"
              size="sm"
              type="button"
              // C5-j：Excel 真打 list export:true（getExcel js:290-330）。
              dataEffect={`list:${pageId}#export`}
              onClick={getExcel}
            >
              Excel
            </Button>
          </>
        }
      >
        {/* 醫院（靜態三軍總醫院，無 name；JSP :22-32）。 */}
        <ReportRow pageId={pageId} name="organizationId" label="醫院：" star>
          <Select
            uiId={`${pageId}-field-organization-id`}
            id="organizationId"
            value={values['organizationId'] ?? ''}
            onChange={(next) => {
              set('organizationId', next);
            }}
            options={[{ value: '7', label: '三軍總醫院' }]}
          />
        </ReportRow>
        {/* 訓練類別（無 name；chosen-select）。 */}
        <div className="flex items-start gap-2">
          <span className="w-24 shrink-0 text-sm">
            <span className="text-danger">*</span>訓練類別：
          </span>
          <Select
            uiId={`${pageId}-field-job-type-id`}
            id="jobTypeId"
            value={values['jobTypeId'] ?? ''}
            onChange={(next) => {
              set('jobTypeId', next);
            }}
            options={ACCOUNT_JOB_TYPE_OPTIONS}
            placeholder="請選擇"
          />
        </div>
        {/* 部門（departmentId select-multiple 契約欄；JSP :34-52 selectpicker multiple）。 */}
        <ReportRow pageId={pageId} name="department-id" label="部門：" star>
          <select
            data-ui-id={`${pageId}-field-department-id`}
            name="departmentId"
            multiple
            className="h-20 rounded border border-border px-1 text-sm"
            value={(values['departmentId'] ?? '') === '' ? [] : (values['departmentId'] ?? '').split(',')}
            onChange={(event) => {
              set('departmentId', [...event.target.selectedOptions].map((option) => option.value).join(','));
            }}
          >
            {/* 批次 52 修訂（b52-calibrate3，F-2）：override 命中（凍結 [-2=無資料]）即取代科部池。 */}
            {(selectOptionsOverride(pageId, 'departmentId') ?? ACCOUNT_DEPARTMENT_OPTIONS).map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </ReportRow>
        {/* 課程月份（StartDate/EndDate dateMonth → type=month required）。 */}
        <ReportRow pageId={pageId} name="start-date" label="課程月份：" star error={undefined}>
          <input
            data-ui-id={`${pageId}-field-start-date`}
            name="StartDate"
            type="month"
            required
            className="rounded border border-border px-2 py-1 text-sm"
            value={values['StartDate'] ?? ''}
            onChange={(event) => {
              set('StartDate', event.target.value);
            }}
          />
        </ReportRow>
        <ReportRow pageId={pageId} name="end-date" label="~">
          <input
            data-ui-id={`${pageId}-field-end-date`}
            name="EndDate"
            type="month"
            required
            className="rounded border border-border px-2 py-1 text-sm"
            value={values['EndDate'] ?? ''}
            onChange={(event) => {
              set('EndDate', event.target.value);
            }}
          />
        </ReportRow>
        {/* 狀態（無 name 靜態已完成；JSP :60-70）。 */}
        <div className="flex items-start gap-2">
          <span className="w-24 shrink-0 text-sm">
            <span className="text-danger">*</span>表單進度狀態：
          </span>
          <span className="text-sm">已完成</span>
        </div>
        <div className="col-span-2">
          {/* 年度列（thead :113-116 colspan=12 id=annual；makeTable js:258 annual 文字照 legacy 無年度後綴）。 */}
          <div data-ui-id={`${pageId}-mom-annual`} className="mb-1 text-center text-sm font-bold">
            {rows[0] === undefined ? '' : String(rows[0]['annual'] ?? '')}
          </div>
          {/* 主表（12 欄；thead :40-52 區塊）。 */}
          <Table
            uiId={`${pageId}-mom-table`}
            columns={momColumns}
            rows={momRows}
            rowKey={(row) => String(row['departmentName'] ?? '')}
            renderCell={(row, columnKey) => {
              if (columnKey === 'departmentName' || columnKey === 'completion' || columnKey === 'remark') {
                return String(row[columnKey] ?? '');
              }
              // 課型儲存格 click → showDetail（js:126-151 → finishModal）。
              const courseTypeName = MOM_COURSE_TYPES[Number(columnKey.replace('ct_', ''))] ?? '';
              return (
                <button
                  type="button"
                  data-ui-id={`${pageId}-mom-cell-${String(row['departmentName'] ?? '')}-${columnKey}`}
                  className="underline"
                  onClick={() => {
                    showDetail(String(row['departmentName'] ?? ''), courseTypeName);
                  }}
                >
                  {String(row[columnKey] ?? '')}
                </button>
              );
            }}
          />
        </div>
      </ReportPanel>

      {/* ── 設定基準數量 modal（#dialogModal，JSP :152-290；契約 tier C 4 欄） ── */}
      {baseOpen ? (
        <ModalFrame
          uiId={`${pageId}-base-dialog`}
          open
          title="設定基準數量"
          size="lg"
          onClose={() => {
            setBaseOpen(false);
          }}
          footer={
            <Button
              uiId={`${pageId}-base-dialog-cancel`}
              variant="default"
              size="sm"
              type="button"
              onClick={() => {
                setBaseOpen(false);
              }}
            >
              關閉
            </Button>
          }
        >
          <div data-ui-id={`${pageId}-base-dialog-body`} className="space-y-3">
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {/* 學年度 d_annualId（name=annualId）。 */}
              <ReportRow pageId={pageId} name="annualId" label="學年度：" star>
                <Select
                  uiId={`${pageId}-base-field-annual-id`}
                  name="annualId"
                  value={baseValues['annualId'] ?? ''}
                  onChange={(next) => {
                    setBaseValues((current) => ({ ...current, annualId: next }));
                  }}
                  options={COURSE_CLAZZ_ANNUAL_OPTIONS}
                />
              </ReportRow>
              {/* 醫院 d_organizationId（靜態三軍總醫院）。 */}
              <ReportRow pageId={pageId} name="d_organizationId" label="醫院：" star>
                <Select
                  uiId={`${pageId}-base-field-d-organization-id`}
                  value={baseValues['d_organizationId'] ?? ''}
                  onChange={(next) => {
                    setBaseValues((current) => ({ ...current, d_organizationId: next }));
                  }}
                  options={[{ value: '7', label: '三軍總醫院' }]}
                />
              </ReportRow>
              {/* 訓練類別 d_jobTypeId（name=jobTypeId）。 */}
              <ReportRow pageId={pageId} name="jobTypeId" label="訓練類別：" star>
                <Select
                  uiId={`${pageId}-base-field-job-type-id`}
                  name="jobTypeId"
                  value={baseValues['jobTypeId'] ?? ''}
                  onChange={(next) => {
                    setBaseValues((current) => ({ ...current, jobTypeId: next }));
                  }}
                  options={ACCOUNT_JOB_TYPE_OPTIONS}
                  placeholder="請選擇"
                />
              </ReportRow>
              <div className="flex items-end gap-2">
                <Button
                  uiId={`${pageId}-base-getbase-btn`}
                  variant="primary"
                  size="sm"
                  type="button"
                  // C5-j：getBase 真的呼叫 dataSource.list（getMOMBaseData 鏡像）。
                  dataEffect={`list:${pageId}`}
                  onClick={getBase}
                >
                  查詢
                </Button>
              </div>
              {/* 匯入課程類別基準數量（uploadFile file required＋檔案匯入）。 */}
              <ReportRow pageId={pageId} name="uploadFile" label="匯入課程類別基準數量：">
                <div className="flex items-center gap-2">
                  <input
                    data-ui-id={`${pageId}-base-field-upload-file`}
                    name="uploadFile"
                    type="file"
                    required
                    className="text-sm"
                    onChange={(event) => {
                      setBaseValues((current) => ({
                        ...current,
                        uploadFile: event.target.files?.[0]?.name ?? '',
                      }));
                    }}
                  />
                  <Button
                    uiId={`${pageId}-base-doimport-btn`}
                    variant="primary"
                    size="sm"
                    type="button"
                    onClick={doImport}
                  >
                    檔案匯入
                  </Button>
                </div>
              </ReportRow>
              {/* 範本下載×3（downloadTemplate；提示呈現）。 */}
              <div className="flex items-start gap-2">
                <span className="w-24 shrink-0 text-sm">使用說明：</span>
                <div className="flex flex-col gap-1">
                  {['西醫UGY範本下載', '中醫UGY範本下載', '牙醫PGY範本下載'].map((label) => (
                    <Button
                      key={label}
                      uiId={`${pageId}-base-template-${label.replace(/[^A-Za-z0-9]/g, '')}`}
                      variant="primary"
                      size="sm"
                      type="button"
                      onClick={() => {
                        void dialogs.info(t('export.notice'));
                      }}
                    >
                      {label}
                    </Button>
                  ))}
                </div>
              </div>
              <div className="text-sm">
                <ol className="ml-4 list-decimal">
                  <li>若資料已存在，將更新系統資料。</li>
                  <li className="text-danger">請務必維護當年度各部門的課類別基準數量。</li>
                </ol>
              </div>
            </div>
            <div className="hr-line-dashed" />
            <div data-ui-id={`${pageId}-base-meta`} className="text-sm">
              <div>{baseMeta === null ? '' : baseMeta.annual}</div>
              <div>{baseMeta === null ? '' : baseMeta.createUser}</div>
            </div>
            {/* 基準數表（10 欄；thead :230-246 區塊）。 */}
            <Table
              uiId={`${pageId}-base-table`}
              columns={baseColumns}
              rows={baseTableRows}
              rowKey={(row) => String(row['departmentName'] ?? '')}
            />
          </div>
        </ModalFrame>
      ) : null}

      {/* ── 已完成表單 modal（#finishModal，JSP :120-148；動態表頭，雛形三欄種子） ── */}
      {detailOpen ? (
        <ModalFrame
          uiId={`${pageId}-finish-dialog`}
          open
          title="已完成表單"
          size="lg"
          onClose={() => {
            setDetailOpen(false);
          }}
          footer={
            <Button
              uiId={`${pageId}-finish-dialog-cancel`}
              variant="default"
              size="sm"
              type="button"
              onClick={() => {
                setDetailOpen(false);
              }}
            >
              關閉
            </Button>
          }
        >
          <div data-ui-id={`${pageId}-finish-dialog-body`}>
            <div className="mb-2 text-sm">{detailTitle}</div>
            <Table
              uiId={`${pageId}-finish-table`}
              columns={[
                { key: 'formName', header: '表單名稱', align: 'left' },
                { key: 'studentName', header: '學員姓名', align: 'center' },
                { key: 'createDate', header: '建立日期', align: 'center' },
              ]}
              rows={detailRows.map((row) => ({ ...row }))}
              rowKey={(row) => String(row['formName'] ?? '')}
            />
          </div>
        </ModalFrame>
      ) : null}
    </div>
  );
}

